import log from '../shared/utils/log';
import { sessionStart, closeTab } from '../shared/actions/index';

export default (store) => {
    store.dispatch(sessionStart());
    window.onbeforeunload = () => {
        store.dispatch(closeTab());
        return null; // Need to return null so there is no alert
    };
    log.info('Session started');
};
